import _ from 'lodash';
import React from 'react';
import { AddBandModal } from 'client/shared/components';

class ArtistSignUpForm extends React.Component {
	render () {

		return (
			<div className="grid-x">
				<div className="large-12">
					<div id="signUpForm" className="center-login">
						<AddBandModal />
					</div>
				</div>
			</div>
		);
	}

	componentDidMount () {
		document.getElementById("signUpForm").scrollIntoView();
	}
};


export default ArtistSignUpForm;
